var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-main-content',{staticClass:"v-benchwave"},[_c('div',{staticClass:"v-benchwave__wrapper"},[_c('iframe',{staticClass:"w-full iframe",style:("width: 100%"),attrs:{"src":_vm.dynamicIframeUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }